module.exports = __webpack_public_path__ + "img/youtube.46d81025.svg";